import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrowsePageService_GetBrowseBannerLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import React from 'react';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {BrowseBannerView} from './BrowseBannerView';

const useBrowseBanner = () => {
  const reductionsState = useReductionsStateRequestParameter();
  const fullSession = useFullSession();
  const targetGroup = useTargetGroupIdentifier();

  return useGrpcRequest(
    BrowsePageService_GetBrowseBannerLazy,
    {
      reductionsState,
      session: fullSession,
      targetGroup,
    },
    {
      disabled: !fullSession,
    },
  );
};

export const BrowseBanner = (props: {className?: string}) => {
  return (
    <DataFetcher
      request={useBrowseBanner()}
      Error={null}
      viewProps={props}
      View={BrowseBannerView}
    />
  );
};
